<template>
<!-- Page length options -->
<div class="card">
    <div>
        <div v-show="onload" class="content bg-white">
            <placeholder-content isLoad="true" />
        </div>
        <div v-if="!onload && hasPermission">
            <access-denied></access-denied>
        </div>
        <div v-show="!onload && !hasPermission" class="card-header bg-white header-elements-inline">
            <h5 class="card-title">{{ $t("Best Seller Report") }}</h5>
        </div>
        <div v-show="!onload && !hasPermission" class="card-body">

            <div v-show="onload">
                <div class="bg-white">
                    <placeholder-content isLoad="true" />
                </div>
            </div>

            <!-- <div class="d-flex align-items-center justify-content-start"> -->
            <div v-show="!onload">
                <div class="d-flex align-items-center justify-content-start border-bottom mb-3 p-3 bg-light mt-n3 mx-n3">
                    <!-- search -->
                    <!-- <div class="toobar-search">
                        <div class="input-group bg-white">
                            <input type="text" @keydown.enter.prevent="search()" v-model="paramsQuery.search" name="search" :placeholder="$t('Product Search')" style="min-width: 225px" class="border-right-0 form-control pl-2 px-0" />
                            <span class="input-group-append">
                                <button class="btn btn-outline-normal border-left-0 btn-search" type="button" @click="search">
                                    <i class="far fa-search"></i>
                                </button>
                            </span>
                        </div>
                    </div> -->

                    <!-- filter calendar -->
                    <span class="nowrap mr-3">{{$t("Data Duration")}}</span>
                    <div class="input-group w-auto">
                        <span class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
                        </span>
                        <date-range-picker style="min-width: 175px" opens="right" :ranges="ranges" v-model="dateRange" :locale-data="localedata" :control-container-class="'form-control rounded-left-0'" @update="applyDatePicker">
                            <div slot="input" v-html="showTextPicker"></div>
                            <div slot="footer" slot-scope="data" class="p-2 drp-buttons">
                                <button @click="cancelDateRange()" v-if="!data.in_selection" type="button" class="applyBtn btn btn-sm btn-secondary">
                                    {{ $t("Cancel") }}
                                </button>
                                <button @click="data.clickApply" v-if="!data.in_selection" type="button" class="applyBtn btn btn-sm btn-primary">
                                    {{ $t("Apply") }}
                                </button>
                            </div>
                        </date-range-picker>
                    </div>

                    <!-- product type -->
                    <div class="d-flex">
                        <span class="d-flex mx-3 align-items-center">{{$t("Product Type")}}</span>
                        <Select2 style="min-width: 175px" class="bg-white" v-model="paramsQuery.productTypeId" v-if="loadProductType" :options="productType" :settings="ProductTypeSetting" @change="changeProductTypeEvent($event)" />
                    </div>
                    <!-- perspective -->
                    <div class="d-flex">
                        <span class="d-flex mx-3 align-items-center">{{ $t("Perspective") }}</span>
                        <Select2 style="min-width: 175px" class="bg-white" v-model="paramsQuery.perspectiveId" v-if="loadPerspective" :options="perspective" :settings="PerspectiveSetting" @change="changePerspectiveEvent($event)" />
                    </div>
                    <div class="d-flex">
                        <button
                            type="button"
                            class="btn btn-outline-normal rounded-left-0 d-flex"
                            data-toggle="modal"
                            data-target="#filter-more"
                        >
                        <i class="fas fa-sliders-v mr-2 mt-1" />
                        {{ $t("More Filters") }}
                        <span
                            v-if="countFilter > 0"
                            class="badge badge-secondary ml-2"
                        >
                            {{ countFilter }}
                        </span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="!onload" class="d-flex flex-wrap">
                <div class="card mr-3" >
                    <div class="card-body">
                        <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-sack-dollar"></i></span>
                        <h6 class="mb-0 font-weight-semibold">{{ $t("Total sales") }}</h6>
                        <h3 class="text-grey-800 font-weight-semibold my-1">฿{{amountTotalSales.amount | formatNumber }}</h3>
                        <div v-if="amountTotalSales.percent == '-' || amountTotalSales.percent == 0" class="text-grey-300"><span class="mr-1">0.00%</span> {{$t('compared to last month')}}</div>
                        <div v-else class="text-grey-300">
                            <span :class="[amountTotalSales.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[amountTotalSales.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']"></i>{{amountTotalSales.percent | formatNumber}}% </span> {{$t('compared to last month')}}
                        </div>
                    </div>
                </div>

                <div class="card mr-3" >
                    <div class="card-body">
                        <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i style="font-size: 11px;" class="fa-solid fa-box"></i></span>
                        <h6 class="mb-0 font-weight-semibold">{{ $t("Number of Products") }}</h6>
                        <h3 class="text-grey-800 font-weight-semibold my-1">{{totalProduct.amount.toFixed(0) | formatNumberDigit }}</h3>
                        <div v-if="totalProduct.percent == '-' || totalProduct.percent == 0" class="text-grey-300"><span class="mr-1">0.00%</span> {{$t('compared to last month')}}</div>
                        <div v-else class="text-grey-300">
                            <span :class="[totalProduct.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[totalProduct.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']"></i>{{totalProduct.percent | formatNumber}}% </span> {{$t('compared to last month')}}
                        </div>
                    </div>
                </div>

                <div class="card mr-3" >
                    <div class="card-body">
                        <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-shopping-cart"></i></span>
                        <h6 class="mb-0 font-weight-semibold">{{ $t("_Shipping.Number of Orders") }}</h6>
                        <h3 class="text-grey-800 font-weight-semibold my-1">{{totalOrder.amount.toFixed(0) | formatNumberDigit }}</h3>
                        <div v-if="totalOrder.percent == '-' || totalOrder.percent == 0" class="text-grey-300"><span class="mr-1">0.00%</span> {{$t('compared to last month')}}</div>
                        <div v-else class="text-grey-300">
                            <span :class="[totalOrder.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[totalOrder.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']"></i>{{totalOrder.percent | formatNumber}}% </span> {{$t('compared to last month')}}
                        </div>
                    </div>
                </div>
            </div>
            <bestseller-chart v-if="!onload" :chartColumns="chartColumns" :yAxisText="yAxisText"></bestseller-chart>

            <div class="d-flex align-items-center dataTables_length mb-2 ml-auto w-100">
                <div class="dataTables_length ml-auto mb-0">
                    <PerPage @per-page="setPerPage" />
                </div>
            </div>

            <div class="card" v-show="!onload">
                <div :class="['table-responsive mt-0 data-nowrap table-order']" id="table-order">
                    <div class="vuetable-wrapper datatable-scroll">
                        <vuetable :class="[loadingTable]" ref="vuetable" :no-data-template="$t('No Data Available')" :fields="table.fields" data-path="data" pagination-path="" :api-mode="false" :data-manager="dataManager" @vuetable:loaded="vuetableLoaded" @vuetable:loading="vuetableLoading" @vuetable:pagination-data="onPaginationData" :sort-order="sort">
                            <template slot="name" slot-scope="props">
                                <div class="d-flex align-items-start">
                                    <span class="mr-2">
                                        <img v-if="props.rowData.product_media_first" class="pointer image_box_variant" data-toggle="modal" data-target="#exampleModalLabel" @click="showimage(props.rowData.product_media_first.media.image_url)" :src="props.rowData.product_media_first.media.image_thumbnail_url ? props.rowData.product_media_first.media.image_thumbnail_url : props.rowData.product_media_first.media.image_url
                                        " />
                                        <img v-else class="image_box_variant" :src="$storeIndex.getImageGobalAssets('')
                                        " />
                                    </span>
                                    <span>
                                        <div
                                          :class="props.rowData.publish == 'deleted' ? 'strikethrough' : 'media-title'"
                                          style="max-width: 400px; white-space: normal;"
                                          >
                                            {{ props.rowData.name }}
                                            <span
                                              v-if="props.rowData.publish == 'deleted'"
                                              class="badge bg-orange w-lg-30"
                                            >
                                              {{ $t("Product is deleted.") }}
                                            </span>
                                        </div>
                                        <div :class="props.rowData.publish == 'deleted' ? 'text-grey-300 font-size-xs strikethrough' : 'text-grey-300 font-size-xs'" v-if="props.rowData.sku">
                                            {{ $t("SKU") }} : {{ props.rowData.sku }}
                                        </div>
                                    </span>
                                </div>
                            </template>
                            <template
                              slot="sum_order_quantity"
                              slot-scope="props"
                            >
                              <span :class="props.rowData.publish == 'deleted' ? 'strikethrough': ''">
                                {{ props.rowData.sum_order_quantity }}
                              </span>

                            </template>
                            <template
                              slot="sum_product_order_quantity"
                              slot-scope="props"
                            >
                              <span :class="props.rowData.publish == 'deleted' ? 'strikethrough': ''">
                                {{ props.rowData.sum_product_order_quantity }}
                              </span>

                            </template>
                            <template
                              slot="sum_product_total"
                              slot-scope="props"
                            >
                              <span :class="props.rowData.publish == 'deleted' ? 'strikethrough': ''">
                                {{ props.rowData.sum_product_total }}
                              </span>

                            </template>
                        </vuetable>
                    </div>
                    <div class="datatable-footer">
                        <vuetable-pagination-info class="dataTables_info ml-3" ref="paginationInfo" :no-data-template="$t('No relevant data')" :info-template="$t('Displaying {from} to {to} of {total} items')"></vuetable-pagination-info>
                        <div class="dataTables_paginate paging_simple_numbers mb-0 mr-2">
                            <vuetable-pagination ref="pagination" pagination-path="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
          class="modal fade"
          tabindex="-1"
          role="dialog"
          id="exampleModalLabel"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <img :src="showbigimage" class="showbigimage" />
              </div>
            </div>
          </div>
        </div>
    </div>

    <BestsellerFiltersMore
        :filter="filter"
        @onSubmit="submitFilters"
    />
</div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import DateRangePicker from "vue2-daterange-picker";
import PerPage from "../PerPage.vue";
import Select2 from "v-select2-component";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
import fields from "../assets/js/bestseller_fields.js";
import {
    showTextPicker,
} from "../assets/directives/Vuetable.js";
import moment from "moment";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";
import numeral from "numeral";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import BestsellerChart from "./BestsellerChart.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import BestsellerFiltersMore from "./BestsellerFiltersMore.vue"
import Cookies from 'js-cookie';
export default {
    components: {
        DateRangePicker,
        PerPage,
        Select2,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        BestsellerFiltersMore,
        PlaceholderContent,
        BestsellerChart,
        AccessDenied
    },
    data() {
        return {
            checkedCount: 0,
            defaultStartDate: moment().subtract(1, 'months').format('YYYY-MM-DD 17:00:00'),
            defaultEndDate: moment().format('YYYY-MM-DD 16:59:59'),
            table: {
                fields: fields,
            },
            showbigimage: '',
            paramsQuery: {
                start_date: this.defaultStartDate,
                end_date: this.defaultEndDate,
                productTypeId: 'all',
                perspectiveId: 'sum_order_quantity',
                per_page: 10,
                current_page: 1,
                sort: '',
                page: 1
            },
            dateRange: {
                startDate: this.defaultStartDate,
                endDate: this.defaultEndDate,
            },
            sort: [{
                field: 'sum_order_quantity',
                direction: 'desc'
            }],
            productType: [],
            perspective: [{
                id: 'sum_order_quantity',
                field: 'sum_order_quantity',
                direction: 'desc',
                sortField: 'sum_order_quantity',
                text: this.$t('_Shipping.Number of Orders')
            },{
                id: 'sum_product_order_quantity',
                field: 'sum_product_order_quantity',
                direction: 'desc',
                sortField: 'sum_product_order_quantity',
                text: this.$t('Number of Products')
            },{
                id: 'sum_product_total',
                field: 'sum_product_total',
                direction: 'desc',
                sortField: 'sum_product_total',
                text: this.$t('Sales')
            }],
            ProductTypeSetting: {
                minimumResultsForSearch: Infinity,
                placeholder: this.$t("Product Type") + "..",
            },
            PerspectiveSetting: {
                minimumResultsForSearch: Infinity,
                placeholder: this.$t("perspective") + "..",
            },
            loadProductType: false,
            loadPerspective: false,
            onload: true,
            hasPermission: true,
            ranges: this.$storeIndex.ranges(),
            localedata: {
                format: 'DD-MM-YYYY',
                applyLabel: this.$t('Apply'),
                cancelLabel: this.$t('Cancel'),
                clearable: true,
                monthNames: this.$storeIndex.monthNames(),
                daysOfWeek: this.$storeIndex.daysOfWeek(),
            },
            dateTxtFilter: null,
            loadingTable: null,
            i: 0,
            chartColumns: {},
            amountTotalSales: {
                amount: 0,
                percent: 0
            },
            totalOrder: {
                amount: 0,
                percent: 0
            },
            totalProduct: {
                amount: 0,
                percent: 0
            },
            yAxisText: this.$t('_Shipping.Number of Orders'),
            filter: {},
            countFilter: 0,
        };
    },
    computed: {
        showTextPicker: function () {
            if (this.dateRange.startDate && this.dateRange.endDate) {
                this.dateRange.startDate = convertTimezone.utcToLocal(this.dateRange.startDate);
                this.dateRange.endDate = convertTimezone.utcToLocal(this.dateRange.endDate);
                this.dateTxtFilter = showTextPicker(this.dateRange);
                return this.dateTxtFilter;
            } else {
                return showTextPicker(this.paramsQuery);
            }
        },
    },
    methods: {
        dataManager(sortOrder, pagination) {
            if (sortOrder.length > 0) {
                this.paramsQuery.sort = sortOrder.map((item) => `${item.sortField}|${item.direction}`).join(',')
            }
            if (this.i++ > 0) {
                this.setParams();
            }
        },
        onPaginationData(tablePagination) {
            this.$refs.paginationInfo.setPaginationData(tablePagination);
            this.$refs.pagination.setPaginationData(tablePagination);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        search() {
            this.setParams();
        },
        changeProductTypeEvent(val) {
            this.setParams(1);
        },
        changePerspectiveEvent(val) {
            let perspective = this.perspective.filter((item) => item.id == val);
            this.yAxisText = perspective[0].text;
            this.sort = perspective;
            this.paramsQuery.sort = perspective.map((item) => `${item.sortField}|${item.direction}`).join(',');
            this.setParams(1);
        },
        setPerPage(perPage) {
            this.paramsQuery.current_page = 1;
            this.$refs.vuetable.currentPage = 1;
            this.paramsQuery.per_page = perPage;
            this.setParams();
        },
        vuetableLoaded() {
            // this.onload = false;
        },
        vuetableLoading() {},
        cancelDateRange() {
            this.paramsQuery.start_date = this.defaultStartDate;
            this.paramsQuery.end_date = this.defaultEndDate;
            $(".daterangepicker").remove();
            this.setParams();
        },
        applyDatePicker(dateRange) {
            let startDate = this.paramsQuery.start_date ? moment(dateRange.startDate).format('YYYY-MM-DD') : null;
            let endDate = this.paramsQuery.end_date ? moment(dateRange.endDate).format('YYYY-MM-DD') : null;
            var afterStartDate = startDate + ' 00:00:00';
            var afterEndDate = endDate + ' 23:59:59';
            this.paramsQuery.start_date = convertTimezone.localToUtc(afterStartDate);
            this.paramsQuery.end_date = convertTimezone.localToUtc(afterEndDate);
            this.setParams(1);
        },
        showimage(data) {
            this.showbigimage = data;
        },
        async setParams(page = null) {
            try {
                if (this.i++ > 0) {
                    this.loadingTable = "loading";
                    this.onload = true;
                }

                if(page == null){
                    this.paramsQuery.page = this.$refs.vuetable.currentPage;
                }else{
                    this.paramsQuery.page = page;
                    this.$refs.vuetable.currentPage = page;
                }
                let queryString = "";
                if (this.paramsQuery) {
                    queryString += "?" + $.param(this.paramsQuery);
                }
                this.setQuerystring(this.paramsQuery);
                let data = this.$storeIndex.mutations.vueTableFormatJson(
                    await Api.Report.getProductBestseller(queryString)
                );
                queryString += "&is_chart=true";
                let dataChart = await Api.Report.getProductBestseller(queryString);
                this.chartColumns = dataChart.data.chartColumns;
                this.amountTotalSales = dataChart.data.amountTotalSales;
                this.totalOrder = dataChart.data.totalOrder;
                this.totalProduct = dataChart.data.totalProduct;
                this.filter = dataChart.data.filter;
                this.$refs.vuetable.setData(data);
                this.loadingTable = "";
                this.hasPermission = false;
                this.onload = false;
            }
            catch (error) {
                if (error.response.status == 403) {
                    this.onload = false;
                    this.hasPermission = true;
                } else {
                    this.$router.push({name: "t.a.home"});
                    console.log(error.response, 'error');
                }
            }
        },
        setQuerystring(obj) {
            this.$router.push({
                query: Object.assign({}, this.$route.query, obj)
            }).catch(() => {});
        },
        submitFilters(data) {
            this.countFilter = 0;
            delete this.paramsQuery.sales_channel_ids;
            delete this.paramsQuery.product_ids;

            if (data.sales_channel.length > 0) {
                this.paramsQuery.sales_channel_ids = data.sales_channel;
                this.countFilter = this.countFilter + data.sales_channel.length;
            }
            if (data.product.length > 0) {
                this.paramsQuery.product_ids = data.product;
                this.countFilter = this.countFilter + data.product.length;
            }

            this.setParams(1);
        }
    },
    async mounted() {
        this.dateRange.startDate = this.paramsQuery.start_date = this.$route.query.start_date ? this.$route.query.start_date : this.defaultStartDate;
        this.dateRange.endDate = this.paramsQuery.end_date = this.$route.query.end_date ? this.$route.query.end_date : this.defaultEndDate;
        this.onload = true;
        let i = 0;

        let publishProductType = ['Simple', 'Config'];
        const features = Cookies.get('features')? JSON.parse(Cookies.get('features')): [];
        if (features.includes('feature-product-set')) {
            publishProductType.push('Set')
        }

        const productType = await Api.ProductType.getProductType();
        this.productType[i] = {
            text: this.$t('All'),
            id: 'all',
        };
        await productType.data.data.forEach((data, key) => {
            if (publishProductType.includes(data.name)) {
                this.productType[++i] = {
                    text: (data.name == 'Set') ? this.$t("Product " + data.name) : this.$t(data.name + " Product"),
                    id: data.id,
                };
            }
        });
        this.loadProductType = true;
        this.loadPerspective = true;
        this.setParams();
    },
    filters: {
        formatNumber: function (value) {
            return numeral(value).format("0,0.00");
        },
        formatNumberDigit: function (value){
          return numeral(value).format("0,0");
        },
    },
};
</script>

<style scoped>
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
    border-top-left-radius: 0.1875rem;
    border-bottom-left-radius: 0.1875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/Bestseller.vue